import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  deleteChatbot,
  fetchDatasources,
  uploadDatasources,
  getPresignedURL,
  getChatbotVerifiedAnswers,
  updateChatbot,
} from "../../services/api/ManagerService";
import { executePipeline } from "../../services/api/PipelineService";
import CardBase from "../../components/Card/CardBase";
import BaseButton from "../../components/Buttons/BaseButton";
import { extractFileExtensions } from "../../services/utils";
import Omnisearch from "../../components/Omnisearch/Omnisearch";
import { FaArrowLeft } from "react-icons/fa6";
import { ClipLoader } from "react-spinners";
import {
  useChatbotCountState,
  useModalUploadFileState,
} from "../../states/useStates";
import PageLayout from "../PageLayout";
import { toast } from "react-hot-toast";
import Dropzone from "../../components/Dropzone/Dropzone";
import ModalFileUpload from "../../components/Modal/ModalFileUpload";
import {
  addTagsToDatasource,
  deleteDatasource,
} from "../../services/api/ManagerService";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { MdDeleteOutline } from "react-icons/md";
import { LuDownload } from "react-icons/lu";
import { CgFileAdd } from "react-icons/cg";
// import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { AiOutlineEdit } from "react-icons/ai";
import { AiOutlineCheckCircle } from "react-icons/ai";

import KnowledgeBaseVerifiedQA from "@/components/KnowledgeBase/KnowledgeBaseVerifiedQA";
import { Button } from "@/components/ui/button";

function ViewSingleKnowledgeBase() {
  const location = useLocation();
  const navigate = useNavigate();
  const [stateLocal] = useState(location.state);
  const [datasources, setDatasources] = useState([]);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState({});
  const [filteredDatasource, setFilteredDatasource] = useState(datasources);
  const [files, setFiles] = useState([]);
  const [executeDeleteSpinner, setExecuteDeleteSpinner] = useState(false);
  const [executePipelineSpinner, setExecutePipelineSpinner] = useState(false);
  const [chatbotCount, setChatbotCount] = useChatbotCountState();
  const [showModal, setShowModal] = useModalUploadFileState(false);
  const [activeUpdateDescription, setActiveUpdateDescription] = useState(false);
  const [chatbot_description, setChatbotDescription] = useState(
    stateLocal.config.chatbot_description
  );
  const [sortOption, setSortOption] = useState("alphabetical");

  const sortDatasources = (option, list) => {
    const sorted = [...list];

    if (option === "alphabetical") {
      sorted.sort((a, b) => a.filename.localeCompare(b.filename));
    } else if (option === "date") {
      sorted.sort(
        (a, b) => new Date(b.time_created) - new Date(a.time_created)
      );
    }

    return sorted;
  };

  useEffect(() => {
    setFilteredDatasource(sortDatasources(sortOption, datasources));
  }, [datasources, sortOption]);

  const configureFileTags = (connector) => {
    let files_tags = [];

    // if (connector === "free-text") {
    //   files.map((file) => {
    //     let tags = {};
    //     const description = file.description;

    //     file.tags.forEach((tag) => {
    //       const [key, value] = tag.text.split("=");
    //       if (key && value) {
    //         tags[key] = value;
    //       }
    //     });
    //     tags["description"] = description;
    //     files_tags.push(tags);
    //   });
    // } else
    if (connector === "structured-text") {
      files.map((file) => {
        let tags = {};
        const description = file.table_description;
        tags["description"] = description;
        tags["column_description"] = file.tags;
        files_tags.push(tags);
      });
    }

    return files_tags;
  };

  const handleFileUpload = async () => {
    const chatbotName = stateLocal.config.chatbot_name;
    // console.log(chatbotName);
    // console.log(files);

    // Tutto da testare, non l'ho ancora provato, manca la parte di pipline
    const res_uploadDatasource = await uploadDatasources(
      chatbotName,
      files
    ).catch((err) => {
      toast.error("Failed during file upload: " + err.response.data.detail);
    });

    let fileTags = [];
    if (stateLocal.config.connector_type === "free-text") {
      fileTags = configureFileTags("free-text");
    } else if (stateLocal.config.connector_type === "structured-text") {
      fileTags = configureFileTags("structured-text");
    } else {
      fileTags = [];
    }

    if (fileTags.length > 0) {
      console.log("Add tags");
      res_uploadDatasource.map((item, index) => {
        addTagsToDatasource(chatbotName, item.id, {
          tags: fileTags[index],
        });
      });
    }

    const pipelinePayload = {
      chatbot_name: chatbotName,
      company_id: localStorage.getItem("company_id"),
    };
    await executePipeline(
      stateLocal.config.connector_type,
      pipelinePayload
    ).catch((err) => {
      console.log(err);
      toast.error("Failed during embeddings: " + err);
    });

    toast.success(
      "Files uploaded successfully. You will receive a notification when the pipeline is completed."
    );
    setFiles([]);
  };

  const handleExecutePipeline = () => {
    setExecutePipelineSpinner(true);
    executePipeline(stateLocal.config, files, () => {
      setExecutePipelineSpinner(false);
      setFiles([]);
      fetchData();
    });
    // window.location.reload();
  };

  const fetchData = async () => {
    fetchDatasources(stateLocal.config.chatbot_name)
      .then((res) => {
        // console.log(res);
        setDatasources(res);
        setFilteredDatasource(res);
      })
      .catch((err) => console.log(err));
  };

  const handleDetailsView = (item) => {
    setSelectedSource(item);
    setDetailsOpen(true);
  };

  const handleDelete = async (target) => {
    if (window.confirm("Are you sure you want to delete the knowledge base?")) {
      setExecuteDeleteSpinner(true);
      await deleteChatbot(target);
      setChatbotCount(chatbotCount - 1);
      navigate("/");
    }
  };

  const handleSearch = (target) => {
    if (target !== "") {
      setDetailsOpen(false);
      const filtered = datasources.filter((item) =>
        item.filename.toLowerCase().includes(target.toLowerCase())
      );
      setFilteredDatasource(filtered);
    } else {
      setFilteredDatasource(datasources);
    }
  };

  useEffect(() => {
    fetchData().catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    if (!showModal) {
      setFiles([]);
    }
  }, [showModal]);

  // useEffect(() => {
  //   setExecutePipelineSpinner(false);
  // }, [datasources]);

  const handleDownload = async (id) => {
    const res = await getPresignedURL(stateLocal.config.chatbot_name, id);
    if (res) {
      window.open(res.presigned_url, "_blank");
    }
  };

  const handleUpdateDescription = async () => {
    const payload = {
      chatbot_description: chatbot_description,
    };

    const res = await updateChatbot(stateLocal.config.chatbot_name, payload);
    if (res) {
      toast.success("Description updated successfully");
      setActiveUpdateDescription(false);
      stateLocal.config.chatbot_description = chatbot_description;
    }
  };

  const handleDeleteDatasource = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete the datasource? This action cannot be undone."
      )
    ) {
      const res = await deleteDatasource(stateLocal.config.chatbot_name, id);
      if (res) {
        toast.success("Datasource deleted successfully");
      }
      fetchData();
    }
  };

  return (
    <PageLayout>
      <div className="pl-2 pr-4 lg:pl-0 pb-2 ">
        <div className="flex gap-x-10 md:mt-10 items-center justify-between h-full">
          <div className="flex gap-x-5 items-center">
            <Link to="/">
              <FaArrowLeft className="opacity-50 hover:opacity-100 cursor-pointer" />
            </Link>
            <h1 className="text-3xl font-bold">
              {stateLocal.config.chatbot_name}
            </h1>
          </div>
        </div>
        <div className="w-full mt-2">
          {activeUpdateDescription ? (
            <div className="flex items-center gap-2">
              <Textarea
                className="w-2/3"
                value={chatbot_description}
                onChange={(e) => setChatbotDescription(e.target.value)}
              />
              <Button
                className="bg-green-400 px-8"
                onClick={handleUpdateDescription}
              >
                Save
              </Button>
              <Button
                className="bg-red-500 hover:bg-red-600 px-8"
                onClick={() => setActiveUpdateDescription(false)}
              >
                Cancel
              </Button>
            </div>
          ) : (
            <div className="flex gap-2">
              <Textarea
                value={stateLocal.config.chatbot_description}
                readOnly
              />
              <AiOutlineEdit
                onClick={() => setActiveUpdateDescription(true)}
                className="cursor-pointer"
              />
            </div>
          )}
        </div>
        <div className="flex flex-col lg:flex-row justify-between gap-y-4 ">
          <div className="lg:w-1/2 lg:mt-4">
            <Omnisearch onSearch={handleSearch} />
          </div>
          <div className="flex items-end gap-5">
            <div className="w-full">
              <KnowledgeBaseVerifiedQA />
            </div>

            <ModalFileUpload
              title="Upload new files"
              openActionLabel={<CgFileAdd className="text-xl" />}
              submitActionLabel="Upload"
              botConfig={stateLocal.config}
              onSubmit={handleFileUpload}
              files={files}
              bodyContent={
                <Dropzone
                  files={files}
                  setFiles={setFiles}
                  botInfo={stateLocal.config}
                  className="p-16 mt-4 rounded outline-dashed outline-[#cbd5e1]"
                />
              }
            />

            {executeDeleteSpinner ? (
              <BaseButton
                onClick={() => handleDelete(stateLocal.config.chatbot_name)}
                value={<ClipLoader size={20} color="red" />}
                styleClass={"border border-red-500 text-red-500"}
              />
            ) : (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <button
                      onClick={() =>
                        handleDelete(stateLocal.config.chatbot_name)
                      }
                      className="p-3 rounded border border-red-500 text-red-500 hover:bg-red-500 hover:text-white text-xl"
                    >
                      <MdDeleteOutline />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p className="text-xs">Delete Datastore</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
        </div>

        <div className="flex justify-end mt-10">
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="text-sm border border-gray-300 rounded-xl px-3 py-1 shadow-sm focus:outline-none focus:ring-2 focus:ring-[#52aeb4]"
          >
            <option value="alphabetical">Sort: A-Z</option>
            <option value="date">Sort: Latest</option>
          </select>
        </div>

        <div className="grid gap-4 mt-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {filteredDatasource &&
            filteredDatasource.map((d, index) => (
              <div
                key={index}
                className="relative rounded-xl p-4 bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 group"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={`${
                      process.env.PUBLIC_URL
                    }/images/file_type/${extractFileExtensions(
                      d.filename,
                      true
                    )}.png`}
                    alt={d.filename}
                    className="w-10 h-10 object-contain"
                  />
                  <div className="flex-1">
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <p className="text-sm font-medium text-gray-800 truncate max-w-[180px]">
                            {d.filename}
                          </p>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-xs">{d.filename}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                    <p className="text-xs text-gray-500">{d.time_created}</p>
                  </div>
                </div>

                <div className="flex justify-between items-center mt-4 text-xs text-gray-500">
                  <span>{d.size_mb} MB</span>
                  <span className="capitalize">
                    {extractFileExtensions(d.filename, false)}
                  </span>
                </div>

                <div className="absolute top-3 right-3 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    onClick={() => handleDownload(d.id)}
                    className="p-2 rounded-full bg-gray-100 bg-primary/60 hover:bg-primary hover:primary-text text-gray-600"
                  >
                    <LuDownload className="text-base" />
                  </button>
                  <button
                    onClick={() => handleDeleteDatasource(d.id)}
                    className="p-2 rounded-full bg-gray-100 bg-red-600/60 hover:bg-red-600/80 hover:text-white transition-colors"
                  >
                    <MdDeleteOutline className="text-base" />
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </PageLayout>
  );
}

export default ViewSingleKnowledgeBase;
